export default __webpack_public_path__ + "static/media/mudupay-logo.47f132d3.png";